import { useEffect, useRef, useState } from "react";
import "../../../assets/css/horizontal_scroll.css";

export const HorizontalScroll = ({ children, step = 320, className = "" }) => {
  const wrapRef = useRef(null);
  const [show, setShow] = useState(false);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const getScroller = () => {
    if (!wrapRef.current) return null;
    return wrapRef.current.querySelector(".table-responsive");
  };

  const update = () => {
    const el = getScroller();
    if (!el) return;

    const overflow = el.scrollWidth > el.clientWidth + 2;
    setShow(overflow);

    if (!overflow) {
      setCanLeft(false);
      setCanRight(false);
      return;
    }

    const atStart = el.scrollLeft <= 0;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2;

    setCanLeft(!atStart);
    setCanRight(!atEnd);
  };

  const scrollByAmount = (amount) => {
    const el = getScroller();
    if (!el) return;
    el.scrollBy({ left: amount, behavior: "smooth" });
  };

  useEffect(() => {
    const el = getScroller();
    if (!el) return;

    update();

    const onScroll = () => update();
    el.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", update);

    const t1 = setTimeout(update, 100);
    const t2 = setTimeout(update, 400);

    return () => {
      el.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", update);
      clearTimeout(t1);
      clearTimeout(t2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div ref={wrapRef} className={`hs-wrap ${className}`}>
      {show && (
        <button
          type="button"
          className="hs-chevron left"
          onClick={() => scrollByAmount(-step)}
          disabled={!canLeft}
          aria-label="Scroll left"
        >
          ‹
        </button>
      )}

      {show && (
        <button
          type="button"
          className="hs-chevron right"
          onClick={() => scrollByAmount(step)}
          disabled={!canRight}
          aria-label="Scroll right"
        >
          ›
        </button>
      )}

      {children}
    </div>
  );
};